export class MaintainAttributesModel {
    constructor (
        public appConfigLocaleCode?: string,
        public appConfigAppServer?: string,
        public appConfigXFwdProto?: string,
        public appConfigBuildInfo?: string,
        public appConfigEncoding?: string,
        public appConfigGitCommit?: string,
        public servConfigAppServer?: string,
        public servConfigServiceUrl?: string,
        public servConfigMediaUrl?: string,
        public servConfigEncoding?: string,
        public servConfigBuildInfo?: string,
        public servConfigGitCommit?: string,
        public servConfigJvmParams?: string,
        public servConfigCredentialsUrl?: string,
        public servConfigQTUrl?: string,
        public servConfigContentAcaSolrUrl?: string,
        public servConfigContentImgSolrUrl?: string,
        public servConfigContentPubSolrUrl?: string,
        public servConfigQuikBibUrl?: string,
        public servConfigAutoCompleteUrl?: string,
        public servConfigTranslatorUrl?: string,
        public servConfigStaticContentUrl?: string,
        public servConfigRecommUrl?: string,
        public servConfigGuidedUIUrl?: string,
        public servConfigGrappleEmailRenderUrl?: string,
        public servConfigPQISPlatformUrl?: string,
        public flushProductInfoCacheUrl?: string,
        public flushProfileInfoCacheUrl?: string,
        public build_date?: string,
        public git_hash?: string,
        public flushCommAssigAndSubjectsCacheUrl?: string,
        public ServMaintainAttributes?: Map<String, String>,
    ) {}
}
